import axios from 'axios';
import { useContext } from 'react';
import { userAuth } from '../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config';

const CommonImageApiService = () => {
	const upload_URL = getConfig().REACT_APP_IMG_UPLOAD_LINK;

	// Get user authentication context and navigation context.
	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	// Function to upload image
	async function uploadImage({ formData, signal, onUploadProgress }) {
		try {
			formData.append('action', 'upload_images');
			const response = await axios.post(upload_URL, formData, {
				signal: signal,
				headers: {},
				onUploadProgress: onUploadProgress,
			});

			if (response.data.type === 'error' && response.data.message === 'Session expired') {
				setToken({});
				localStorage.removeItem('user-auth');
				navigate('/');
			}

			return response;
		} catch (error) {
			throw error;
		}
	}

	return { uploadImage };
};

export default CommonImageApiService;
